module.exports = __webpack_public_path__ + "static/media/Seam_6920.69b54846.jpg";